import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@core/header/header.component';
import { SidebarComponent } from '@core/sidebar/sidebar.component';
import { ApplicationStore } from '@core/store/application.store';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'fc-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrl: './default-layout.component.scss',
  standalone: true,
  imports: [HeaderComponent, RouterOutlet, SidebarComponent, MatSidenavModule],
})
export class DefaultLayoutComponent {
  private readonly applicationStore = inject(ApplicationStore);

  readonly isOpened: Signal<boolean> = this.applicationStore.getIsMenuOpened;
  readonly isMobile: Signal<boolean> = this.applicationStore.isMobile;

  closeMenu(): void {
    this.applicationStore.closeMenu();
  }
}
